<script>
    import TextAttributeBase from './TextAttributeBase';

    export default {
        extends: TextAttributeBase,
        data() {
            return {
            }
        },
        computed: {
            values() {
                return _.orderBy(this.attribute.values, 'text_attribute_value.text', 'asc');
            }
        },
        methods: {
            storeValueDropdown() {
                if (this.storeValueData.text_attribute_context_value) {
                    this.storeValueData.text_attribute_context_value_id = this.storeValueData.text_attribute_context_value.id;
                }

                this.storeValue();
            },
            updateDropdownValue() {
                if (this.updateValueData.text_attribute_context_value) {
                    this.updateValueData.text_attribute_context_value_id = this.updateValueData.text_attribute_context_value.id;
                }

                this.updateValue();
            },
        },
    }
</script>

<template>
    <div :class="[withCols ? 'col-lg-12': '']">
        <div class="panel panel-default">
            <div class="panel-heading">
                <span v-html="headline"></span>
                <a class="pull-right" @click="storeValueDropdown" v-if="!isLocked && canAddAnotherValue"><i class="fa fa-save"></i></a>
                <i class="pull-right fa fa-lock" v-if="isLocked"></i>
            </div>
            <div class="panel-body">
                <div class="row">
                    <div class="col-md-6"></div>
                    <div :class="[hasContext ? 'col-md-6': 'col-md-12']">
                        <label class="text-center small" style="width: 77px">Höhe cm</label>
                        <label class="text-center small" style="width: 77px">Breite cm</label>
                        <label class="text-center small" style="width: 77px">Tiefe cm</label>
                        <label class="text-center small" style="width: 77px">Länge cm</label>
                        <label class="text-center small" style="width: 77px">Ø cm</label>
                        <label class="text-center small" style="width: 77px">Gewicht kg</label>
                        <label class="text-center small" style="width: 77px">Füllmenge ml</label>
                    </div>
                </div>
                <div v-for="value in values" class="row m-b-sm">
                    <div v-if="isLocked">
                        <div v-if="hasContext" class="col-md-6">
                            <input readonly type="text" class="form-control" :value="value.text_attribute_context_value ? value.text_attribute_context_value.context_label : ''">
                        </div>
                        <div :class="[hasContext ? 'col-md-6': 'col-md-12']">
                            <div class="input-group m-b">
                                <input readonly type="text" class="form-control text-center" :value="value.height" style="width: 80px">
                                <input readonly type="text" class="form-control text-center" :value="value.width" style="width: 80px">
                                <input readonly type="text" class="form-control text-center" :value="value.depth" style="width: 80px">
                                <input readonly type="text" class="form-control text-center" :value="value.length" style="width: 80px">
                                <input readonly type="text" class="form-control text-center" :value="value.diameter" style="width: 80px">
                                <input readonly type="text" class="form-control text-center" :value="value.weight" style="width: 80px">
                                <input readonly type="text" class="form-control text-center" :value="value.filling_volume" style="width: 80px">
                            </div>
                        </div>
                    </div>
                    <Lightbox
                            v-if="!isLocked"
                            :id="lightboxId(value.id)"
                            :headline="headline"
                            :large="true"
                    >
                        <span slot="open-template" @click="selectToUpdate(value)">
                            <div v-if="hasContext" class="col-md-6">
                                <input type="text" class="form-control" :value="value.text_attribute_context_value ? value.text_attribute_context_value.context_label : ''">
                            </div>
                            <div :class="[hasContext ? 'col-md-6': 'col-md-12']">
                                <div class="input-group m-b">
                                    <input type="text" class="form-control text-center" :value="value.height" style="width: 80px">
                                    <input type="text" class="form-control text-center" :value="value.width" style="width: 80px">
                                    <input type="text" class="form-control text-center" :value="value.depth" style="width: 80px">
                                    <input type="text" class="form-control text-center" :value="value.length" style="width: 80px">
                                    <input type="text" class="form-control text-center" :value="value.diameter" style="width: 80px">
                                    <input type="text" class="form-control text-center" :value="value.weight" style="width: 80px">
                                    <input type="text" class="form-control text-center" :value="value.filling_volume" style="width: 80px">
                                </div>
                            </div>
                        </span>
                        <div slot="body" class="text-left">
                            <div class="row">
                                <div class="col-md-4"></div>
                                <div :class="[hasContext ? 'col-md-8': 'col-md-12']">
                                    <label class="text-center small" style="width: 77px">Höhe cm</label>
                                    <label class="text-center small" style="width: 77px">Breite cm</label>
                                    <label class="text-center small" style="width: 77px">Tiefe cm</label>
                                    <label class="text-center small" style="width: 77px">Länge cm</label>
                                    <label class="text-center small" style="width: 77px">Ø cm</label>
                                    <label class="text-center small" style="width: 77px">Gewicht kg</label>
                                    <label class="text-center small" style="width: 77px">Füllmenge ml</label>
                                </div>
                            </div>
                            <div class="row">
                                <div v-if="hasContext" class="col-md-4">
                                    <v-select v-model="updateValueData.text_attribute_context_value" :options="contextValues" label="context_label" class="white-bg"></v-select>
                                </div>
                                <div :class="[hasContext ? 'col-md-8': 'col-md-12']">
                                    <div class="input-group m-b">
                                        <input type="text" class="form-control text-center" v-model="updateValueData.height"
                                               @keyup.enter="updateDropdownValue" placeholder="Höhe" style="width: 80px">
                                        <input type="text" class="form-control text-center" v-model="updateValueData.width"
                                               @keyup.enter="updateDropdownValue" placeholder="Breite" style="width: 80px">                                        
                                        <input type="text" class="form-control text-center" v-model="updateValueData.depth"
                                               @keyup.enter="updateDropdownValue" placeholder="Tiefe" style="width: 80px">
                                        <input type="text" class="form-control text-center" v-model="updateValueData.length"
                                               @keyup.enter="updateDropdownValue" placeholder="Länge" style="width: 80px">
                                        <input type="text" class="form-control text-center" v-model="updateValueData.diameter"
                                               @keyup.enter="updateDropdownValue" placeholder="Ø" style="width: 80px">
                                        <input type="text" class="form-control text-center" v-model="updateValueData.weight"
                                               @keyup.enter="updateDropdownValue" placeholder="Gewicht kg" style="width: 80px">
                                        <input type="text" class="form-control text-center" v-model="updateValueData.filling_volume"
                                               @keyup.enter="updateDropdownValue" placeholder="Füllmenge ml" style="width: 80px">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-cloak slot="footer">
                            <div class="pull-left">
                                <button type="button" class="btn btn-danger" @click="deleteValue(value.id)" v-text="__('scoop-os.common.delete')"></button>
                            </div>
                            <button type="button" class="btn btn-white" data-dismiss="modal" v-text="__('scoop-os.common.close')"></button>
                            <button class="btn btn-primary" @click="updateDropdownValue">Update</button>
                        </div>
                    </Lightbox>
                </div>
                <div v-if="!isLocked && canAddAnotherValue" class="row">
                    <div v-if="hasContext" class="col-md-6">
                        <v-select v-model="storeValueData.text_attribute_context_value" :options="contextValues" label="context_label"></v-select>
                    </div>
                    <div :class="[hasContext ? 'col-md-6': 'col-md-12']">
                        <div class="input-group m-b">
                            <input type="text" v-model="storeValueData.height" class="form-control text-center p-l-none p-r-none"
                                   @keyup.enter="storeValueDropdown" placeholder="Höhe cm" style="width: 80px">
                            <input type="text" v-model="storeValueData.width" class="form-control text-center p-l-none p-r-none"
                                   @keyup.enter="storeValueDropdown" placeholder="Breite cm" style="width: 80px">
                            <input type="text" v-model="storeValueData.depth" class="form-control text-center p-l-none p-r-none"
                                   @keyup.enter="storeValueDropdown" placeholder="Tiefe cm" style="width: 80px">
                            <input type="text" v-model="storeValueData.length" class="form-control text-center p-l-none p-r-none"
                                   @keyup.enter="storeValueDropdown" placeholder="Länge cm" style="width: 80px">
                            <input type="text" v-model="storeValueData.diameter" class="form-control text-center p-l-none p-r-none"
                                   @keyup.enter="storeValueDropdown" placeholder="Ø cm" style="width: 80px">
                            <input type="text" v-model="storeValueData.weight" class="form-control text-center p-l-none p-r-none"
                                   @keyup.enter="storeValueDropdown" placeholder="Gewicht kg" style="width: 80px">
                            <input type="text" v-model="storeValueData.filling_volume" class="form-control text-center p-l-none p-r-none"
                                   @keyup.enter="storeValueDropdown" placeholder="Füllmenge ml" style="width: 80px">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>